export default "__VITE_ASSET__CsVaRNNr__"